import { Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-footer',
  imports: [RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
   encapsulation: ViewEncapsulation.None 
})
export class FooterComponent {
   blogUrl = environment.blogUrl;
}
